export type MinViewsRequirement =
  | { kind: 'none' }
  | { kind: 'minimum'; views: number };

/**
 * What a CPM campaign's `min_views_threshold` means for a clipper. A zero (or
 * missing) threshold is a state of its own — every view earns from the first
 * one — so campaign cards say so instead of leaving the line out, which read
 * as "unknown" rather than "no minimum".
 */
export function describeMinViewsRequirement(
  minViewsThreshold?: number | null,
): MinViewsRequirement {
  if (
    minViewsThreshold == null
    || !Number.isFinite(minViewsThreshold)
    || minViewsThreshold <= 0
  ) {
    return { kind: 'none' };
  }
  return { kind: 'minimum', views: minViewsThreshold };
}
